common.View.create('canvas::editor.tooltip', {

    onDOMLoad()
    {
        if(this.isAdmin())
        {
            this.showTooltipOnHover();
            //this.showCanvasElementTooltips();
        }
    },

    isAdmin()
    {
        return $('body').hasClass('canvas::editor-website-Page');
    },

    showTooltipOnHover()
    {
        this.element.on('mouseover', (event) => {
            // Element has canvas overview?
            if( $('.canvas\\:\\:editor-website-Page').hasClass('canvas-overview')
                && (
                    this.element.is(':first-child')
                        ? !this.element.prev().hasClass('galaxyTooltip')
                        : !this.element.after().hasClass('galaxyTooltip')
                )
            ) {
                // Insert after if first child so no extra padding gets added
                if( !this.element.is(':first-child') ) {
                    this.element.before(this.tooltipElement.bind(this));
                } else {
                    this.element.after(this.tooltipElement.bind(this));
                }
            }
        }).on('mouseout', (event) => {
            $('.canvas\\:\\:editor-website-Page .canvas\\:\\:Canvas > .galaxyTooltip').remove();
        });
    },

    showCanvasElementTooltips()
    {
        $('.canvas\\:\\:editor-website-Page').on('classChange', (event) => {
            // Is canvas overview?
            if( $(event.currentTarget).hasClass('canvas-overview') && !this.element.prev().hasClass('galaxyTooltip') ) {

                // Insert after if first child so no extra padding gets added
                if( !this.element.is(':first-child') ) {
                    this.element.before(this.tooltipElement.bind(this));
                } else {
                    this.element.after(this.tooltipElement.bind(this));
                }

            } else {
                $('.canvas\\:\\:editor-website-Page .canvas\\:\\:Canvas > .galaxyTooltip').remove();
            }
        });
    },

    tooltipElement()
    {
        return '<div class="pointer-events-none '+
            (this.element.is(':first-child') ? 'translate-y-full' : '-translate-y-full')
            +' absolute bg-white galaxyTooltip px-12 py-3 rounded rounded-2xl text-center leading-normal transform w-full z-50" ' +
            'style="font-size: 80px;margin-top: 30px;box-shadow: 0 2px 14px 5px #0000002e;'+
                (this.element.is(':first-child') ? 'top: calc(' + this.element.height() + 'px / 2)' : '')
            +'">' +
                '<div class="absolute '+ (this.element.is(':first-child') ? 'top-2 -translate-y-full' : 'bottom-2 translate-y-full') +' left-0 ml-44 transform" style="\n' +
                ' border-left: 50px solid transparent;\n' +
                ' border-'+ (!this.element.is(':first-child') ? 'top' : 'bottom')
                    +': 60px solid white;\n' +
                ' border-right: 50px solid transparent;\n' +
                '"></div>' +
                this.element.data('name')
            + '</div>'

        // Tooltip for showing it at all times above a block
        // return '<div class="galaxyTooltip bg-white border-b border-black border-solid rounded-tl-2xl rounded-tr-2xl text-center w-full z-50" style="' +
        //             'font-size: 80px; margin-bottom: -5rem;' +
        //         '">' +
        //         this.element.data('name')
        //         + '</div>';
    }

});
